import { Link } from "react-router-dom";
import { WhatsappLogo, Phone, Envelope, MapPin } from "@phosphor-icons/react";
import { IMAGES, COMPANY, WHATSAPP_QUOTE_URL, navLinks } from "@/data/site";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="main-footer" className="bg-[#234D89] text-white py-16">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Logo and description */}
          <div className="md:col-span-2">
            <img
              src={IMAGES.logo}
              alt="Finegraf Acabamentos"
              className="h-16 w-auto object-contain mb-6"
            />
            <p className="text-white/70 max-w-md mb-6">
              Acabamentos gráficos de qualidade superior para empresas de todo o Brasil.
            </p>
            <div className="flex gap-4">
              <a
                href={WHATSAPP_QUOTE_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Conversar no WhatsApp"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#25D366] transition-colors"
              >
                <WhatsappLogo size={20} weight="fill" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Links Rápidos</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-white/70 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Contato</h4>
            <ul className="space-y-3 text-white/70">
              <li className="flex items-center gap-2">
                <Phone size={16} />
                {COMPANY.phone}
              </li>
              <li className="flex items-center gap-2">
                <WhatsappLogo size={16} />
                {COMPANY.whatsapp}
              </li>
              <li className="flex items-center gap-2">
                <Envelope size={16} />
                {COMPANY.email}
              </li>
              <li className="flex items-start gap-2 pt-1">
                <MapPin size={16} className="flex-shrink-0 mt-1" />
                <a
                  href={COMPANY.address.directionsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors leading-snug"
                >
                  {COMPANY.address.street}
                  <br />
                  {COMPANY.address.district} — {COMPANY.address.city}
                  <br />
                  CEP {COMPANY.address.zip}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 pt-8">
          <p className="text-center text-white/50 text-sm">
            © {currentYear} Finegraf Acabamentos Gráficos. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
